import ImportExportAPI from "@/apis/ImportExport/ImportExportAPI.js";
import { MSEnum } from "@/commons/enumeration";

export default {
  debug: process.env.NODE_ENV !== 'production',
	namespaced: true,

  state: {

  },

  getters: {
    
  },

  mutations: {
    
  },

  actions: {
    
    /**
     * upload file nhập khẩu yêu cầu
     * ndhuy1 30/09/2022
     */
     async ConvertFileData(context, param) {
      return new Promise((resolve, reject) => {
        ImportExportAPI.ConvertFileData(param)
            .then((res) => { 
              if (res.data?.Status && res.data?.Data) {
                resolve(res?.data);
              } else if (!res.data?.Status) {
                reject(res.data?.ValidateInfo);
              }
            })
            .catch((err) => {
              reject(err)
            })
      })
    },
     
  }

}
